(function () {
    angular.module('tradersyard').component('tyInvitationsScreenInviteFriends', {
        bindings: {
            entryType: '@',
            entryId: '@',
        },
        controller: InvitationsScreenInviteFriendsCtrl,
        // language=HTML
        template: `
            <div class="invitation-sreen-invite-friends">
                <input ng-model="$ctrl.friendSearchQuery"
                       ng-model-options="{debounce: 200}"
                       ng-change="$ctrl.onSearchQueryChange($ctrl.friendSearchQuery)"
                       class="form-control input-lg" type="search" placeholder="Type here to search for people...">

                <h2 ng-show="$ctrl.isLoading" class="text-center">
                    <span class="fa fa-spin fa-spinner"></span> Loading...
                </h2>
                <h3 ng-show="!$ctrl.isLoading && !$ctrl.people.length" class="text-center text-muted">
                    No search results
                </h3>
                <ty-invitations-people-list
                        people="$ctrl.people"
                        on-invite="$ctrl.onInvite(person)"
                        ng-hide="$ctrl.isLoading">
                </ty-invitations-people-list>
            </div>
        `,
    });

    InvitationsScreenInviteFriendsCtrl.$inject = [
        'graph-friend-factory',
        'graph-search-factory',
        'graph-invite-factory',
        '$scope',
    ];

    function InvitationsScreenInviteFriendsCtrl(friendApiFactory, searchApiFactory, inviteApiFactory, $scope) {
        const ctrl = this;

        const DEFAULT_SEARCH_PARAMS = {
            page: 1,
            let: 0,
            limit: 25,
        };

        let friendApi; // graph-friend-factory.entry
        let searchApi; // graph-search-factory.place
        let inviteApi; // graph-invite-factory.entry

        /**
         * Indicates that some API request is in progress.
         * Starts with loading state - avoid showing "no results" message.
         * @type {boolean}
         */
        ctrl.isLoading = true;

        /**
         * @type {string|undefined}
         */
        ctrl.friendSearchQuery = undefined;

        /**
         * List of people objects.
         * @type {object[]}
         */
        ctrl.people = [];

        ctrl.$onInit = digest($onInit);
        ctrl.onInvite = digest(onInvite);
        ctrl.onSearchQueryChange = digest(onSearchQueryChange);

        async function $onInit() {
            ctrl.isLoading = true;

            // create API services
            friendApi = friendApiFactory.entry(ctrl.entryType, ctrl.entryId);
            searchApi = searchApiFactory.place(ctrl.entryType, ctrl.entryId);
            inviteApi = inviteApiFactory.entry(ctrl.entryType, ctrl.entryId);

            try {
                ctrl.people = await _getFriendList();
            } finally {
                ctrl.isLoading = false;
            }
        }

        async function onInvite(person) {
            await _invitePerson(person);
            person.is_invited = true;
        }

        async function onSearchQueryChange(newQueryValue) {
            ctrl.isLoading = true;
            const promise = newQueryValue ? _searchFriendList(newQueryValue) : _getFriendList();

            try {
                ctrl.people = await promise;
            } finally {
                ctrl.isLoading = false;
            }
        }

        async function _getFriendList() {
            const resp = await friendApi.query({ params: DEFAULT_SEARCH_PARAMS });
            return _promisifyResponse(resp, []);
        }

        async function _searchFriendList(query) {
            const params = { ...DEFAULT_SEARCH_PARAMS, q: query };
            const resp = await searchApi.search('friend', { params });
            return _promisifyResponse(resp, []);
        }

        async function _invitePerson(person) {
            const resp = await inviteApi.create(person.id, {});
            return _promisifyResponse(resp);
        }

        function _promisifyResponse(response, defaultData = undefined) {
            return response.data.state === 0 ? response.data.data ?? defaultData : Promise.reject();
        }

        function digest(func) {
            return (...args) => func(...args).finally(() => $scope.$digest());
        }
    }
})();
